// Shared labels and status styling for the sales assessment admin screens.
// Band and flag colours are status colours: always shown with an icon and a
// text label, never colour alone.

export const BANDS = {
    high_potential: { label: 'High Potential', icon: 'mdi-star-circle', color: '#0ca30c', tint: '#e6f6e6' },
    potential: { label: 'Potential', icon: 'mdi-trending-up', color: '#c98a00', tint: '#fff6e0' },
    low_potential: { label: 'Low Potential', icon: 'mdi-circle-outline', color: '#d0672f', tint: '#fdeee7' },
}

export const FLAG_LEVELS = {
    red: { icon: 'mdi-alert-octagon', color: '#d03b3b', label: 'Important' },
    amber: { icon: 'mdi-alert', color: '#c98a00', label: 'Check' },
    info: { icon: 'mdi-information', color: '#2a78d6', label: 'Note' },
}

export const FLAG_SHORT = {
    evenings: 'Evenings',
    commute: 'Commute',
    impression: 'Idealised answers',
    inconsistent: 'Inconsistent',
    straight_lining: 'Same answers',
    too_fast: 'Very fast',
    too_good: 'Too good to be true',
    attention: 'Missed attention check',
    ai_written: 'Likely AI-written',
    generic_text: 'Generic text',
    pasted: 'Pasted text',
    concerning: 'Concerning answer',
    ai_low_confidence: 'AI unsure',
    floor: 'Low resilience/coachability',
}

export const REVIEW_STATUSES = [
    { value: 'new', text: 'New' },
    { value: 'shortlisted', text: 'Shortlisted' },
    { value: 'interview', text: 'Interview' },
    { value: 'hired', text: 'Hired' },
    { value: 'rejected', text: 'Not progressing' },
]

export const CATEGORY_ORDER = [
    'resilience', 'coachability', 'drive', 'work_ethic', 'empathy', 'persuasion', 'integrity', 'communication',
]

// Matches SalesAssessmentAdminController::deny(): recruitment access or Super Admin.
export function hasAssessmentAccess(user) {
    if (!user) return false
    if (user.is_recruitment_access === 1 || user.role_id === 1) return true
    return !!(user.role_members && user.role_members.some(m => m.user_role_id === 1))
}

export function reviewStatusText(value) {
    const found = REVIEW_STATUSES.find(s => s.value === value)
    return found ? found.text : value
}

// Most severe level present, for summarising a candidate's flags as one count.
export function topFlagLevel(flags) {
    const levels = (flags || []).map(f => f.level)
    return ['red', 'amber', 'info'].find(l => levels.includes(l)) || null
}
